module.exports = __webpack_public_path__ + "img/light-Path 17 Copy@3x.6d8b0b32.png";